import type { RouteRecordRaw } from "vue-router";

export const imageRoutes: RouteRecordRaw[] = [
  // AI Images
  {
    path: "/ai/images",
    name: "ai_image-index",
    component: () => import("./images/ImageGeneratorPage.vue"),
    meta: {
      title: "tools_meta.ai_images_prefix",
    },
  },
  {
    path: "/ai/images/history",
    name: "ai_image-history",
    component: () => import("./images/history.vue"),
    meta: {
      title: "tools_meta.ai_images_prefix",
    },
  },
  {
    path: "/ai/images/history/:id",
    name: "ai_image-show",
    component: () => import("./images/history/ImageHistoryDetailPage.vue"),
    meta: {
      title: "tools_meta.ai_images_prefix",
    },
  },
  {
    path: "/ai/images/info",
    name: "ai_image-info",
    component: () => import("./images/info.vue"),
    meta: {
      title: "tools_meta.ai_images_prefix",
    },
  },
];
